import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CalendarDatePicker from "./CalendarDatePicker";
import dayjs from 'dayjs';
import CalendarTimePicker from "./CalendarTimePicker";
import moment from "moment";
import { AuthContext } from "../../../context";
import { env } from "../../../env";
import axios from "axios";
import Swal from "sweetalert2";

const EventCreateModal = ({ eventDetails, sendShowCreateModal, customerData, kindOfAppointmentList, appointmentTypeList }) => {

    const { t } = useTranslation();
    const [showType, setShowType] = useState(false);
    const [showKindType, setShowKindType] = useState(false);
    const [appointmentType, setAppointmentType] = useState("");
    const [appointmentKindType, setAppointmentKindType] = useState("");
    const authContext = useContext(AuthContext);
    const [inputs, setInputs] = useState({
        userName: "",
        customerName: "",
        fromTime: "",
        toTime: "",
        appointmentDate: "",
        appointmentTypeName: "",
        kindOfAppointmentName: "",
        comment: ""
    });

    useEffect(() => {
        setInputs((prev) => ({
            ...prev,
            userName: authContext.userInfo.userName,
            customerName: customerData.name,
            appointmentDate: dayjs(),
            fromTime: eventDetails.start,
            toTime: eventDetails.end,
        }));
    }, [eventDetails, customerData]);

    const handleShowCreateModal = (e) => {
        e.preventDefault();
        sendShowCreateModal()
    };
    const handleAppointmentType = (e, data) => {
        e.preventDefault();
        setAppointmentType(data);
        setShowType(false);
        setInputs((prev) => ({
            ...prev,
            appointmentTypeName: data
        }));
    };
    const handleAppointmentKindType = (e, data) => {
        e.preventDefault();
        setAppointmentKindType(data);
        setShowKindType(false);
        setInputs((prev) => ({
            ...prev,
            kindOfAppointmentName: data
        }));
    };
    const handleDateDataFromChild = (data) => {
        setInputs((prev) => ({
            ...prev,
            appointmentDate: data.date
        }));
    };
    const handleTimeDataFromChild = (data) => {
        setInputs((prev) => ({
            ...prev,
            fromTime: data.fromTime,
            toTime: data.toTime,
        }));
    };
    const handleChange = (e) => {
        setInputs((prev) => ({
            ...prev,
            comment: e.target.value
        }));
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        Swal.fire({
            title: `${ t("are you sure")}?`,
            text: `${ t("you want to create new appointment")}?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: `${ t("yes")}!`,
            cancelButtonText: `${ t("cancel")}!`
        }).then((result) => {
            if (result.isConfirmed) {  
                const baseUrl = env.REACT_APP_API_URL;
                const token = localStorage.getItem('token');      
                const requestData = {
                    "userName": inputs.userName,
                    "customerName": inputs.customerName,
                    "fromTime": moment(inputs.fromTime).format("HH:mm"),
                    "toTime": moment(inputs.toTime).format("HH:mm"),
                    "appointmentDate": moment(inputs.appointmentDate).format("DD/MM/YYYY"),
                    "appointmentTypeName": inputs.appointmentTypeName,
                    "kindOfAppointmentName": inputs.kindOfAppointmentName,
                    "comment": inputs.comment
                }

                console.log(requestData);
                axios.post(baseUrl+"/api/CustomerDetails/InsertAppointments", requestData, {
                    headers : {
                        "Accept" : "Application/json",
                        "Content-Type" : "Application/json",
                        "Authorization" : `Bearer ${token}`,
                        "APIkey": authContext.userInfo.apiKey,
                    }
                }).then((response) => {
                    console.log(response);
                }).catch((error) => {
                    console.log(error);
                    // if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                    //     localStorage.removeItem("token");
                    //     localStorage.removeItem("userInfo");
                    //     window.location.reload();
                    // }
                });
            }
        });

    }

    return (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-end sm:items-center z-50">
            <form onSubmit={handleSubmit}>
                <div className="bg-white rounded-t-lg sm:rounded-lg shadow-lg w-[34rem] p-2 sm:p-6 space-y-2 sm:space-y-4">
                    <div className="flex justify-between items-center">
                        <div className='flex items-center space-x-2'>
                            <h3 className="text-lg font-semibold capitalize">
                                { t('create appointment')}
                            </h3>
                        </div>
                        <button type="button" onClick={(e) => handleShowCreateModal(e)} className="text-gray-500 hover:text-gray-700">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"/>
                            </svg>
                        </button>
                    </div>
                    <div className='space-y-2'>
                        <div className='grid sm:grid-cols-2 gap-2'>
                            <div className='bg-gray-dark3 rounded-md p-4 h-full flex items-start space-x-2'>
                                <img className='w-5 h-5' src="../../assets/icons/profile/icon/type.svg" alt='type' />
                                <div className='ml-7 text-sm'>{customerData.name}</div>
                            </div>
                            <div className='bg-gray-dark3 rounded-md p-4 h-full relative flex items-start space-x-2'>
                                <img className='w-5 h-5' src="../../assets/icons/profile/icon/location.svg" alt='location' />
                                <div className='ml-7 text-sm'>{customerData.address}</div>
                                <div className='absolute z-40 top-2 right-2 cursor-pointer'>
                                    <img className='bg-white p-2 rounded-md shadow-md' src="../../assets/icons/profile/icon/redirect.svg" alt='redirect' />
                                </div>
                            </div>
                        </div>
                        <div className='grid grid-cols-2 gap-2'>
                            <div className="space-y-1">
                                <div className='flex items-start space-x-2'>
                                    <label className='text-xs sm:text-sm capitalize text-light-700'>{t('appointment date')} :</label>
                                </div>
                                <div className='flex justify-between text-xs sm:text-sm bg-white border border-background-normal rounded-md px-4 py-2.5'>
                                    <CalendarDatePicker setDataFromChild={handleDateDataFromChild} startDate={dayjs()} dateInput={inputs.appointmentDate ? inputs.appointmentDate : dayjs()} name={'date'}/>
                                </div>
                            </div>
                            <div className="space-y-1">
                                <div className='flex items-start space-x-2'>
                                    <label className='text-xs sm:text-sm capitalize text-light-700'>{t('appointment time')} :</label>
                                </div>
                                <div className='flex justify-between text-xs sm:text-sm bg-white border border-background-normal rounded-md px-4 py-2.5'>
                                    <CalendarTimePicker startDateTime={inputs.fromTime ? inputs.fromTime : eventDetails.start} endDateTime={inputs.toTime ? inputs.toTime : eventDetails.end} sendTimeDataFromChild={handleTimeDataFromChild} />
                                </div>
                            </div>
                            <div className="space-y-1">
                                <div className='flex items-start space-x-2'>
                                    <label className='text-xs sm:text-sm capitalize text-light-700'>{t('appointment type')} :</label>
                                </div>
                                <div className='text-sm bg-white border border-background-normal rounded-md px-4 py-2 relative'>
                                    <button type="button" onClick={(e) => setShowType(!showType)} className="flex justify-between items-center w-full">
                                        <span className={`mr-1 text-xs sm:text-sm capitalize ${appointmentType ? "text-black" : "text-gray-dark"}`}>
                                            {appointmentType || t("select")}
                                        </span>
                                        <img src="../../assets/icons/select-down.svg" alt="select-down" />
                                    </button>
                                    {showType && (
                                        <ul className="absolute left-0 w-full min-h-auto max-h-28 overflow-y-auto no-scrollbar z-10 text-background-dark bg-white shadow-md rounded-md top-10">
                                            {appointmentTypeList && appointmentTypeList.map((type, index) => (
                                                <li key={"type"+index} onClick={(e) => handleAppointmentType(e, type.title)} className="cursor-pointer bg-white hover:bg-action-hover px-3 py-2 block whitespace-no-wrap capitalize text-xs sm:text-sm">
                                                    {type.title}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>
                            <div className="space-y-1">
                                <div className='flex items-start space-x-2'>
                                    <label className='text-xs sm:text-sm capitalize text-light-700'>{t('kind of appointment type')} :</label>
                                </div>
                                <div className='text-sm bg-white border border-background-normal rounded-md px-4 py-2 relative'>
                                    <button type="button" onClick={(e) => setShowKindType(!showKindType)} className="flex justify-between items-center w-full">
                                        <span className={`mr-1 text-xs sm:text-sm capitalize ${appointmentKindType ? "text-black" : "text-gray-dark"}`}>
                                            {appointmentKindType || t("select")}
                                        </span>
                                        <img src="../../assets/icons/select-down.svg" alt="select-down" />
                                    </button>
                                    {showKindType && (
                                        <ul className="absolute left-0 w-full min-h-auto max-h-28 overflow-y-auto no-scrollbar z-10 text-background-dark bg-white shadow-md rounded-md top-10">
                                            {kindOfAppointmentList && kindOfAppointmentList.map((kind, index) => (
                                                <li key={"kind"+index} onClick={(e) => handleAppointmentKindType(e, kind.title)} className="cursor-pointer bg-white hover:bg-action-hover px-3 py-2 block whitespace-no-wrap capitalize text-xs sm:text-sm">
                                                    {kind.title}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>
                        </div>
                        <textarea value={inputs.comment} onChange={handleChange} className="bg-white border border-background-normal rounded-md px-4 py-2 w-full relative flex items-start focus:outline-none" rows={3} columns={9} placeholder={ t("write comments here...")}></textarea>
                    </div>
                    <div className="flex justify-between items-center">
                        <button onClick={(e) => handleShowCreateModal(e)} className="px-4 py-2 bg-white text-gray-dark4 capitalize font-medium border-2 border-background-normal rounded-lg">
                            { t('close')}
                        </button>
                        <button className="px-4 py-2 bg-blue-normal text-white rounded-lg capitalize">
                            { t('create appointment')}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default EventCreateModal;
